import { cn } from "@client/lib";

const TOTAL_STEPS = 2;

export function InviteClientProgressBar({
  currentStep,
  stepLabel,
}: {
  currentStep: number;
  stepLabel: string;
}) {
  const steps = Array.from({ length: TOTAL_STEPS });

  return (
    <div className="mb-2 w-full space-y-2 pr-8">
      <div className="flex items-center gap-2">
        {steps.map((_, idx) => (
          <div
            key={idx}
            className={cn('h-1 w-full rounded-full bg-gray-200', {
              'bg-primary': idx + 1 < currentStep || idx + 1 === currentStep,
            })}
          />
        ))}
      </div>
      <div className="flex items-center gap-2 text-xs">
        <span className="font-semibold text-gray-950">{stepLabel}</span>
        <span className="text-gray-700">•</span>
        <span className="text-gray-700">
          Step {currentStep} of {TOTAL_STEPS}
        </span>
      </div>
    </div>
  );
}
